import templates from "../components/templates/Templates";
export var Filter = {
    type: "filter",
    path: "filters",
    sanitized: "filter"
};
export var Exam = {
    type: "exam",
    path: "exams",
    sanitized: "exam",
    template: templates.ExamTemplate
};
export var Page = {
    type: "page",
    path: "pages",
    sanitized: "page",
    template: templates.PageTemplate
};
export var MediaPage = {
    type: "media_page",
    path: "media_pages",
    sanitized: "mediapage",
    template: templates.MediaTemplate
};
export var Sequence = {
    type: "sequence",
    path: "sequences",
    sanitized: "sequence",
    template: templates.SequenceTemplate
};
export var DdQuestion = {
    type: "dd_question",
    path: "dd_questions",
    sanitized: "ddquestion",
    template: templates.CompatibleDnDTemplate
};
export var Question = {
    type: "question",
    path: "questions",
    qtype: "richtigfalsch",
    sanitized: "question",
    template: templates.SingleChoiceTemplate
};
export var Catchit = {
    type: "question",
    path: "questions",
    qtype: "catchit",
    sanitized: "question",
    template: templates.CatchItTemplate
};
export var Pinit = {
    type: "question",
    path: "questions",
    qtype: "pinit",
    sanitized: "question",
    template: templates.PinItTemplate
};
export var Multiple = {
    type: "question",
    path: "questions",
    qtype: "multiplechoice",
    sanitized: "question",
    template: templates.MultipleChoiceTemplate
};
export var DragDrop = {
    type: "question",
    path: "questions",
    qtype: "dragndrop",
    sanitized: "question",
    template: templates.MultipleChoiceDnDTemplate
};
export var ExtensionPage = {
    type: "extension_page",
    path: "extension_pages",
    sanitized: "extensionpage",
    template: null
};
export var TemplatePage = {
    type: "template_page",
    path: "template_pages",
    sanitized: "templatepage",
    template: templates.TemplatePageTemplate
};
export var CorePage = {
    type: "CorePage",
    path: "core_pages",
    sanitized: "corepage",
    template: templates.CoreSlideTemplate
};
export var ExternalContentPage = {
    type: "external_content_page",
    path: "external_content_pages",
    sanitized: "externalcontentpage",
    template: templates.ExternalContentTemplate
};
export default {
    Filter: Filter,
    Exam: Exam,
    Page: Page,
    MediaPage: MediaPage,
    Sequence: Sequence,
    DdQuestion: DdQuestion,
    Question: Question,
    Catchit: Catchit,
    Pinit: Pinit,
    Multiple: Multiple,
    DragDrop: DragDrop,
    ExtensionPage: ExtensionPage,
    TemplatePage: TemplatePage,
    CorePage: CorePage,
    ExternalContentPage: ExternalContentPage
};
